export default "__VITE_ASSET__BYprVjLD__"